
























import Component from 'vue-class-component'
import Vue from 'vue'
import Icon from '@/components/Icon.vue'

@Component({
  components: {
    Icon
  },
  props: {
    showClearIcon: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String
    },
    type: {
      type: String,
      default: 'text'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: [String, Number],
      default: ''
    }
  }
})
export default class SearchInput extends Vue {
  opened: boolean = false

  emitInput (event: any) {
    this.$emit('input', event.target.value)
  }

  change (event: any) {
    this.$emit('change', event.target.value)
  }

  enter (event: any) {
    this.$nextTick(() => {
      this.$emit('enter', event.target.value)
    })
  }
}
